import _ from 'lodash';


export function isCourtDrive() {
  return /courtdrive/i.test(window.location.hostname);
}

export function isProd() {
  return !/dev.azk.io/i.test(window.location.hostname);
}

export function drupalPermsInclude(permission) {
  return _.some(window.Drupal.settings.PERMS, p => _.lowerCase(p).includes(_.lowerCase(permission)));
}

export function getCourtCodeAndCaseNumFromUrl() {
  const urlPathsegments = window.location.href.split('/')
  const lastPathSegment = urlPathsegments[urlPathsegments.length - 1];
  const caseUUIDSegments = lastPathSegment.split('-').splice(0,4)
  const case_uuid = `${caseUUIDSegments[1]}:${caseUUIDSegments[2]}-${caseUUIDSegments[3]}-${caseUUIDSegments[4]}`;
  const court_code = caseUUIDSegments[0];
  return { case_uuid, court_code };
}



// WEBPACK FOOTER //
// ./src/util/globalUtils.js